export const toHourMinute = value => {
  if (value === null || value === undefined || value === '') {
    return value
  }

  const normalized = String(value).trim()
  const match = normalized.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/)

  if (!match) {
    return normalized
  }

  return `${match[1].padStart(2, '0')}:${match[2]}`
}

export const normalizePhoneAvailability = availability => {
  if (!Array.isArray(availability)) {
    return []
  }

  return availability.map(dayAvailability => ({
    ...dayAvailability,
    slots: Array.isArray(dayAvailability.slots)
      ? dayAvailability.slots.map(slot => ({
        ...slot,
        start: toHourMinute(slot.start),
        end: toHourMinute(slot.end),
      }))
      : [],
  }))
}
